export const LeadQueryTypes = [
  { value: 'want_to_raise_funds', text: 'Want to raise funds' },
  { value: 'transaction_related_query', text: 'Transaction related query' },
  { value: 'other_query', text: 'Other query' }
];